import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { Menu, Icon } from 'semantic-ui-react'

export const AdminSidebarView = ({
  resourceOptions,
  showNotifications,
  showTranslations,
}) => (
  <Menu text vertical className='text vertical app-side-nav'>
    <Menu.Item
      as={NavLink}
      end
      to={'/'}
      data-automation-id={'return-to-marketplace'}
      data-testid='admin-sidebar-home-link'
    >
      <Icon name='chevron left' />
      Return to Home Screen
    </Menu.Item>
    <hr />
    {resourceOptions.map(({ text, href, icon }) => (
      <Menu.Item className='resource' key={href} as={NavLink} to={href}>
        <Icon name={icon} /> {text}
      </Menu.Item>
    ))}
    {showNotifications && (
      <>
        <hr />
        <Menu.Item
          className='resource'
          key='/admin/notifications'
          as={NavLink}
          to='/admin/notifications'
          data-testid='admin-sidebar-notifications-link'
        >
          <Icon name='bell' /> Push Notifications
        </Menu.Item>
      </>
    )}
    {showTranslations && (
      <>
        <hr />
        <Menu.Item
          className='resource'
          as={NavLink}
          to='/admin/translations'
          data-testid='admin-sidebar-translations-link'
        >
          <Icon name='language' /> Translations
        </Menu.Item>
      </>
    )}
  </Menu>
)

AdminSidebarView.propTypes = {
  resourceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    }),
  ).isRequired,
  showNotifications: PropTypes.bool.isRequired,
  showTranslations: PropTypes.bool.isRequired,
}
